import {computed, obtainActiveLocale} from "#imports";
import PlaceAttraction from "~/lib/models/PlaceAttraction";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import PlaceTouristRegion from "~/lib/models/PlaceTouristRegion";
import PlaceCity from "~/lib/models/PlaceCity";
import PlaceCountry from "~/lib/models/PlaceCountry";
import {Widget} from "../../lib/interfaces/model/Widget";


export function useWidget(widget: PageDataHolderFetchedWidget) {

    const content = computed(() => widget.content as { type: string, location: { [k: string]: any } })

    const location = computed(() => {
        const location = content.value.location;
        if (content.value.type === 'attraction') {
            return (new PlaceAttraction()).fromObject(location);
        } else if (content.value.type === 'tourist_region') {
            return (new PlaceTouristRegion()).fromObject(location);
        } else if (content.value.type === 'city') {
            return (new PlaceCity()).fromObject(location);
        } else if (content.value.type === 'country') {
            return (new PlaceCountry()).fromObject(location);
        }
        return new PlaceAttraction();
    });

    const activeLocale = obtainActiveLocale();
    return {
        widgetData: widget.widget as Widget,
        content: content.value as { type: string, location: { [k: string]: any } },
        location: location.value as PlaceAttraction | PlaceTouristRegion | PlaceCity | PlaceCountry,
        activeLocale: activeLocale as { code: String, name: String, iso: String }
    };
}
